// UTILS
import { markRaw, ref, shallowRef } from "vue"
import { defineStore } from "pinia"
import Bugsnag from "@bugsnag/js"

// STORES
import { useImportantModalStore } from "@/features/brain/legacy/components/ImportantModal/importantModal.store"

export const useBrainLayoutStore = defineStore("brainLayoutStore", () => {
  const { openModal } = useImportantModalStore()

  const brainInstance = shallowRef(null)
  const allowActions = ref(false)
  const isSkipAction = ref(true)
  const isConfirmAction = ref(false)

  // User actions to track
  const trackMoves = ref(0) // how many times the user moved tokens
  const trackOversights = ref(0) // how many times the user skipped and cancelled skip modal
  const trackResets = ref(0) // how many times the user reset the test

  const instructionsDone = ref(false)

  let resetTimeout

  /**
   * Set the brain instance
   * @param instance - The brain instance
   */
  function setBrainInstance(instance) {
    brainInstance.value = instance ? markRaw(instance) : instance
  }

  /**
   * Reset the current step
   */
  async function resetCurrentStep() {
    resetTimeout = setTimeout(() => {
      if (brainInstance.value?.rawResetTest) {
        brainInstance.value.rawResetTest()
      } else if (window?.b?.rawResetTest) {
        window.b.rawResetTest()
      } else {
        Bugsnag.notify(
          new Error("Brain instance not yet initialized"),
          (event) => {
            event.context = "Brain.resetCurrentStep"
            event.severity = "error"
            event.unhandled = true
            event.addMetadata("brain_state", {
              data: window?.b,
            })
          }
        )
      }
      clearTimeout(resetTimeout)
    }, 1000)
  }

  /**
   * Show the skip CTA
   */
  function showSkipCTA() {
    if (isSkipAction.value) return
    isConfirmAction.value = false
    isSkipAction.value = true
  }

  /**
   * Show the confirm CTA
   */
  function showConfirmCTA() {
    if (isConfirmAction.value) return
    isConfirmAction.value = true
    isSkipAction.value = false
  }

  /**
   * Hide the CTA
   */
  function hideCTA() {
    isConfirmAction.value = false
    isSkipAction.value = false
  }

  /**
   * Skip the current step
   */
  function skipStep() {
    openModal("incompleteAnswer", {
      actionPrimary: () => {
        window.b.sendAnswer()
      },
      actionSecondary: () => trackOversights.value++,
    })
  }

  return {
    allowActions,
    instructionsDone,
    isSkipAction,
    isConfirmAction,
    brainInstance,
    setBrainInstance,
    resetCurrentStep,
    showSkipCTA,
    showConfirmCTA,
    hideCTA,
    skipStep,
    trackMoves,
    trackOversights,
    trackResets,
  }
})
